import { Outlet, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Sidebar from "./Sidebar";

import { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "../frontend/Landingpage/Subcomponents/Footer";
import UploadStatusWidget from "../shared/Upload/UploadStatusWidget";

const BackendLayout = ({
  currentLanguage,
  setCurrentLanguage,
  groups = [],
  setGroups,
}) => {
  const [showSidebar, setShowSidebar] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setShowSidebar(false);
  }, [location]);

  return (
    <>
      <Header
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        currentLanguage={currentLanguage}
        setCurrentLanguage={setCurrentLanguage}
      />
      <Sidebar
        showSidebar={showSidebar}
        groups={groups}
        setGroups={setGroups}
      />
      <div className="main-content" >
        <div style={{ minHeight: "100vh" }}>
        <div className="page-content">
          <Container fluid>
            <Outlet />
          </Container>
        </div>
        </div>
        <Footer />
      </div>
      {/* uploads keep running when their modal closes; this keeps them visible */}
      <UploadStatusWidget />
    </>
  );
};

export default BackendLayout;
